import Vue from 'vue';
import jQuery from 'jquery';
window.$=jQuery;

var VueComponents = {};
var vueComponentList = [
  require.context(".", false, /.+\.vue$/),
];

for(let vueComponentListItem of vueComponentList)
  for(let key of vueComponentListItem.keys()) {
    let actualKey=key.replace(/\.vue|.*\//g, "");
    let actualComponent=vueComponentListItem(key).default;
    VueComponents[actualKey]=actualComponent;
    Vue.component(actualKey, actualComponent);
  }


import appScroll from './scrollbar';
appScroll();

import utilZoom from './util-zoom';
utilZoom();

import mainMenu from './main-menu';
mainMenu();

import homeIntro from './homeintro';
homeIntro();

import elastic from './elastic';
elastic();

import drag from './drag';
drag();

import map from './map';
map();

import news from './news';
news();


(function() {
  var loadingVideo=$(".loading-video");
  if (loadingVideo.length)
    setTimeout(()=>loadingVideo.removeClass("show"), 7000);
  $(".loading-video video")[0] && $(".loading-video video")[0].addEventListener("ended", ()=>loadingVideo.removeClass("show"));
})();


var dynamicVue=function() {
  $("[vue-dyn]").each(function() {
    this.removeAttribute("vue-dyn");
    new Vue({el: this});
  });
};
dynamicVue();

import loadpage from './loadpage';
loadpage({appScroll, utilZoom, mainMenu, homeIntro, elastic, dynamicVue, map, drag, news});
